
export default {
  namespaced: true,
  state: {
    details: {
      customerPhone: false,
      customerEmail: false,
      address: false,
      itemsOrdered: false,
      orderMessage: false,
      shippingMethod: false,
      extraInfo: false,
      source: false,
      scheduledDateTime: false
    },
  },
  mutations: {
    recoverFollowUpDetails (state) {
      let followUpDetails = localStorage.getItem('yz_follow_up_details')
      if (followUpDetails) {
        followUpDetails = JSON.parse(followUpDetails)
        state.details = followUpDetails
      }
    },
    setFollowUpDetails (state, details) {
      state.details = details
      localStorage.setItem('yz_follow_up_details', JSON.stringify(details))
    },
  },
  getters: {
    getFollowUpDetails (state) {
      return state.details
    }
  }
}